import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { RnwyEngineResult } from '../shared/forms/rnwyVenues';

// item 1450 — the live engine preview as a hook (the same debounced POST the Pricing step's
// RnwyOptionsPreview makes; that component is left untouched). Used by the Venues step to print each
// venue's cost in its header. `enabled=false` (portal builder, manually priced deal) never fetches.
const useRnwyPreview = (venuesJson: string, cfgJson: string, enabled: boolean): RnwyEngineResult | null => {
  const [result, setResult] = useState<RnwyEngineResult | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const firstRun = useRef(true);
  useEffect(() => {
    if (!enabled) return undefined;
    if (timer.current) clearTimeout(timer.current);
    const delay = firstRun.current ? 0 : 600;
    firstRun.current = false;
    let cancelled = false;
    timer.current = setTimeout(async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASIX_API || '';
        const { data } = await axios.post(`${apiUrl}proposal/rnwy-preview`, { venuesJson, cfgJson });
        if (!cancelled) setResult(data as RnwyEngineResult);
      } catch {
        if (!cancelled) setResult(null);
      }
    }, delay);
    return () => { cancelled = true; if (timer.current) clearTimeout(timer.current); };
  }, [venuesJson, cfgJson, enabled]);
  return enabled ? result : null;
};

export default useRnwyPreview;
